import { render, staticRenderFns } from "./travelPhotoEn.vue?vue&type=template&id=77b8b183&scoped=true&lang=html&"
import script from "./travelPhotoEn.vue?vue&type=script&lang=js&"
export * from "./travelPhotoEn.vue?vue&type=script&lang=js&"
import style0 from "./travelPhotoEn.vue?vue&type=style&index=0&id=77b8b183&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8b183",
  null
  
)

export default component.exports